export default {
  async adapterData({ commit }, { projectData }) {
    const hasJsonFeatureFlagsField = !!projectData.enabledFeatureFlags
    if (hasJsonFeatureFlagsField) {
      commit('storeFeatureFlags', projectData.enabledFeatureFlags)
    }
  },
}
